import env from '../env';

export async function getCurrentRegion(): Promise<string> {
  try {
    const res = await fetch(env.pingDomain);
    const { region } = await res.json();
    return region;
  } catch (exception) {
    return 'us-central1';
  }
}
